export type Icon =
  | 'add'
  | 'address-book'
  | 'alarm-clock'
  | 'align-center'
  | 'align-justify'
  | 'align-left'
  | 'align-right'
  | 'ambulance'
  | 'angle-double-left'
  | 'angle-double-right'
  | 'angle-double-small-left'
  | 'angle-double-small-right'
  | 'angle-down'
  | 'angle-left'
  | 'angle-right'
  | 'angle-small-down'
  | 'angle-small-left'
  | 'angle-small-right'
  | 'angle-small-up'
  | 'angle-up'
  | 'apple'
  | 'apps-add'
  | 'apps-delete'
  | 'apps-sort'
  | 'apps'
  | 'archive'
  | 'arrow-down'
  | 'arrow-from-bottom'
  | 'arrow-left'
  | 'arrow-right'
  | 'arrow-small-down'
  | 'arrow-small-left'
  | 'arrow-small-right'
  | 'arrow-small-up'
  | 'arrow-up'
  | 'asterik'
  | 'at'
  | 'backpack'
  | 'badge'
  | 'balloons'
  | 'ban'
  | 'band-aid'
  | 'bank'
  | 'barber-shop'
  | 'baseball'
  | 'basketball'
  | 'bed'
  | 'beer'
  | 'bell-ring'
  | 'bell-school'
  | 'bell'
  | 'bike'
  | 'billiard'
  | 'bold'
  | 'book-alt'
  | 'book'
  | 'bookmark'
  | 'bowling'
  | 'box-alt'
  | 'box'
  | 'bread-slice'
  | 'briefcase'
  | 'broom'
  | 'browser'
  | 'brush'
  | 'bug'
  | 'building'
  | 'bulb'
  | 'butterfly'
  | 'cake-birthday'
  | 'cake-wedding'
  | 'calculator'
  | 'calendar'
  | 'call-history'
  | 'call-incoming'
  | 'call-missed'
  | 'call-outgoing'
  | 'camera'
  | 'camping'
  | 'car'
  | 'caret-down'
  | 'caret-left'
  | 'caret-right'
  | 'caret-up'
  | 'carrot'
  | 'chart-connected'
  | 'chart-histogram'
  | 'chart-network'
  | 'chart-pie-alt'
  | 'chart-pie'
  | 'chart-pyramid'
  | 'chart-set-theory'
  | 'chart-tree'
  | 'chat-arrow-down'
  | 'chat-arrow-grow'
  | 'check'
  | 'checkbox'
  | 'cheese'
  | 'chess-piece'
  | 'child-head'
  | 'circle-small'
  | 'circle'
  | 'clip'
  | 'clock'
  | 'cloud-check'
  | 'cloud-disabled'
  | 'cloud-download'
  | 'cloud-share'
  | 'cloud-upload'
  | 'cloud'
  | 'clouds'
  | 'cocktail'
  | 'coffee'
  | 'comment-alt'
  | 'comment-check'
  | 'comment-heart'
  | 'comment-info'
  | 'comment-user'
  | 'comment'
  | 'comments'
  | 'compress-alt'
  | 'compress'
  | 'computer'
  | 'confetti'
  | 'cookie'
  | 'copy-alt'
  | 'copy'
  | 'copyright'
  | 'cow'
  | 'cream'
  | 'credit-card'
  | 'croissant'
  | 'cross-circle'
  | 'cross-small'
  | 'cross'
  | 'crown'
  | 'cube'
  | 'cupcake'
  | 'cursor-finger'
  | 'cursor-plus'
  | 'cursor-text-alt'
  | 'cursor-text'
  | 'cursor'
  | 'dart'
  | 'dashboard'
  | 'data-transfer'
  | 'database'
  | 'delete'
  | 'diamond'
  | 'dice'
  | 'diploma'
  | 'disco-ball'
  | 'disk'
  | 'doctor'
  | 'document-signed'
  | 'document'
  | 'dollar'
  | 'download'
  | 'drink-alt'
  | 'drumstick'
  | 'duplicate'
  | 'e-learning'
  | 'earnings'
  | 'edit-alt'
  | 'edit'
  | 'envelope-ban'
  | 'envelope-download'
  | 'envelope-marker'
  | 'envelope-open'
  | 'envelope-plus'
  | 'envelope'
  | 'euro'
  | 'exclamation'
  | 'expand'
  | 'eye-crossed'
  | 'eye-dropper'
  | 'eye'
  | 'feather'
  | 'ferris-wheel'
  | 'file-add'
  | 'file-ai'
  | 'file-check'
  | 'file-delete'
  | 'file-eps'
  | 'file-gif'
  | 'file-music'
  | 'file-psd'
  | 'file'
  | 'fill'
  | 'film'
  | 'filter'
  | 'fingerprint'
  | 'fish'
  | 'flag'
  | 'flame'
  | 'flip-horizontal'
  | 'flower-bouquet'
  | 'flower-tulip'
  | 'flower'
  | 'folder-add'
  | 'folder'
  | 'following'
  | 'football'
  | 'form'
  | 'forward'
  | 'fox'
  | 'frown'
  | 'ftp'
  | 'gallery'
  | 'gamepad'
  | 'gas-pump'
  | 'gem'
  | 'gift'
  | 'glass-cheers'
  | 'glasses'
  | 'globe-alt'
  | 'globe'
  | 'golf'
  | 'graduation-cap'
  | 'graphic-tablet'
  | 'grid-alt'
  | 'grid'
  | 'guitar'
  | 'gym'
  | 'hamburger'
  | 'hand-holding-heart'
  | 'hastag'
  | 'hat-birthday'
  | 'head-side-thinking'
  | 'headphones'
  | 'headset'
  | 'heart-arrow'
  | 'heart'
  | 'home-location-alt'
  | 'home-location'
  | 'home'
  | 'hourglass-end'
  | 'hourglass'
  | 'ice-cream'
  | 'ice-skate'
  | 'id-badge'
  | 'inbox'
  | 'incognito'
  | 'indent'
  | 'infinity'
  | 'info'
  | 'interactive'
  | 'interlining'
  | 'interrogation'
  | 'italic'
  | 'jpg'
  | 'key'
  | 'keyboard'
  | 'kite'
  | 'label'
  | 'laptop'
  | 'lasso'
  | 'laugh'
  | 'layers'
  | 'layout-fluid'
  | 'leaf'
  | 'letter-case'
  | 'life-ring'
  | 'line-width'
  | 'link'
  | 'lipstick'
  | 'list-check'
  | 'list'
  | 'location-alt'
  | 'lock-alt'
  | 'lock'
  | 'logo-facebook'
  | 'logo-instagram'
  | 'logo-linkedin'
  | 'logo-messenger'
  | 'logo-pinterest'
  | 'logo-reddit'
  | 'logo-snapchat'
  | 'logo-telegram'
  | 'logo-tiktok'
  | 'logo-tumblr'
  | 'logo-whatsapp'
  | 'logo-x'
  | 'logo-youtube'
  | 'luggage-rolling'
  | 'magic-wand'
  | 'makeup-brush'
  | 'man-head'
  | 'map-marker-cross'
  | 'map-marker-home'
  | 'map-marker-minus'
  | 'map-marker-plus'
  | 'map-marker'
  | 'map'
  | 'marker-time'
  | 'marker'
  | 'mars-double'
  | 'mars'
  | 'mask-carnival'
  | 'medicine'
  | 'megaphone'
  | 'meh'
  | 'menu-burger'
  | 'menu-dots-vertical'
  | 'menu-dots'
  | 'microphone-alt'
  | 'microphone'
  | 'minus-small'
  | 'minus'
  | 'mobile'
  | 'mode-landscape'
  | 'mode-portrait'
  | 'money'
  | 'moon'
  | 'mountains'
  | 'mouse'
  | 'mug-alt'
  | 'music-alt'
  | 'music'
  | 'navigation'
  | 'network-cloud'
  | 'network'
  | 'notebook'
  | 'opacity'
  | 'package'
  | 'paint-brush'
  | 'palette'
  | 'paper-plane'
  | 'password'
  | 'pause'
  | 'paw'
  | 'pencil'
  | 'pharmacy'
  | 'phone-call'
  | 'phone-cross'
  | 'phone-pause'
  | 'phone-slash'
  | 'physics'
  | 'picture'
  | 'ping-pong'
  | 'pizza-slice'
  | 'plane'
  | 'play-alt'
  | 'play'
  | 'playing-cards'
  | 'plus-small'
  | 'plus'
  | 'poker-chip'
  | 'portrait'
  | 'pound'
  | 'power'
  | 'presentation'
  | 'print'
  | 'protractor'
  | 'pulse'
  | 'pyramid'
  | 'quote-right'
  | 'rainbow'
  | 'raindrops'
  | 'rec'
  | 'receipt'
  | 'record-vinyl'
  | 'rectabgle-vertical'
  | 'rectangle-horizontal'
  | 'rectangle-panoramic'
  | 'recycle'
  | 'redo-alt'
  | 'redo'
  | 'reflect'
  | 'refresh'
  | 'resize'
  | 'resources'
  | 'rewind'
  | 'rhombus'
  | 'rings-wedding'
  | 'road'
  | 'rocket'
  | 'room-service'
  | 'rotate-right'
  | 'rugby'
  | 'sad'
  | 'salad'
  | 'scale'
  | 'school-bus'
  | 'school'
  | 'scissors'
  | 'screen'
  | 'search-alt'
  | 'search-heart'
  | 'search'
  | 'settings-sliders'
  | 'settings'
  | 'share'
  | 'shield-check'
  | 'shield-exclamation'
  | 'shield-interrogation'
  | 'shield-plus'
  | 'shield'
  | 'ship-side'
  | 'ship'
  | 'shop'
  | 'shopping-bag-add'
  | 'shopping-bag'
  | 'shopping-cart-add'
  | 'shopping-cart-check'
  | 'shopping-cart'
  | 'shuffle'
  | 'sign-in-alt'
  | 'sign-in'
  | 'sign-out-alt'
  | 'sign-out'
  | 'signal-alt-1'
  | 'signal-alt-2'
  | 'signal-alt'
  | 'skateboard'
  | 'smartphone'
  | 'smile-wink'
  | 'smile'
  | 'snowflake'
  | 'soap'
  | 'soup'
  | 'spa'
  | 'speaker'
  | 'sphere'
  | 'spinner-alt'
  | 'spinner'
  | 'square-root'
  | 'square'
  | 'star-octogram'
  | 'star'
  | 'stats'
  | 'stethoscope'
  | 'sticker'
  | 'stop'
  | 'stopwatch'
  | 'subtitles'
  | 'sun'
  | 'sunrise'
  | 'surfing'
  | 'sword'
  | 'syringe'
  | 'tablet'
  | 'target'
  | 'taxi'
  | 'tennis'
  | 'terrace'
  | 'test-tube'
  | 'test'
  | 'text-check'
  | 'text'
  | 'thermometer-half'
  | 'thumbs-down'
  | 'thumbs-up'
  | 'thumbtack'
  | 'ticket'
  | 'time-add'
  | 'time-check'
  | 'time-delete'
  | 'time-fast'
  | 'time-forward-sixty'
  | 'time-forward-ten'
  | 'time-forward'
  | 'time-half-past'
  | 'time-oclock'
  | 'time-past'
  | 'time-quarter-past'
  | 'time-quarter-to'
  | 'time-twenty-four'
  | 'tool-crop'
  | 'tool-marquee'
  | 'tooth'
  | 'tornado'
  | 'train-side'
  | 'train'
  | 'transform'
  | 'trash'
  | 'treatment'
  | 'tree-christmas'
  | 'tree'
  | 'triangle'
  | 'trophy'
  | 'truck-side'
  | 'umbrella'
  | 'underline'
  | 'undo-alt'
  | 'undo'
  | 'unlock'
  | 'upload'
  | 'usb-pendrive'
  | 'user-add'
  | 'user-delete'
  | 'user-remove'
  | 'user-time'
  | 'user'
  | 'utensils'
  | 'vector-alt'
  | 'vector'
  | 'venus-double'
  | 'venus-mars'
  | 'venus'
  | 'video-camera'
  | 'volleyball'
  | 'volume'
  | 'wheelchair'
  | 'wifi-alt'
  | 'wind'
  | 'woman-head'
  | 'world'
  | 'yen'
  | 'zoom-in'
  | 'zoom-out';

export const TISA_ICONS: readonly Icon[] = [
  'add',
  'address-book',
  'alarm-clock',
  'align-center',
  'align-justify',
  'align-left',
  'align-right',
  'ambulance',
  'angle-double-left',
  'angle-double-right',
  'angle-double-small-left',
  'angle-double-small-right',
  'angle-down',
  'angle-left',
  'angle-right',
  'angle-small-down',
  'angle-small-left',
  'angle-small-right',
  'angle-small-up',
  'angle-up',
  'apple',
  'apps-add',
  'apps-delete',
  'apps-sort',
  'apps',
  'archive',
  'arrow-down',
  'arrow-from-bottom',
  'arrow-left',
  'arrow-right',
  'arrow-small-down',
  'arrow-small-left',
  'arrow-small-right',
  'arrow-small-up',
  'arrow-up',
  'asterik',
  'at',
  'backpack',
  'badge',
  'balloons',
  'ban',
  'band-aid',
  'bank',
  'barber-shop',
  'baseball',
  'basketball',
  'bed',
  'beer',
  'bell-ring',
  'bell-school',
  'bell',
  'bike',
  'billiard',
  'bold',
  'book-alt',
  'book',
  'bookmark',
  'bowling',
  'box-alt',
  'box',
  'bread-slice',
  'briefcase',
  'broom',
  'browser',
  'brush',
  'bug',
  'building',
  'bulb',
  'butterfly',
  'cake-birthday',
  'cake-wedding',
  'calculator',
  'calendar',
  'call-history',
  'call-incoming',
  'call-missed',
  'call-outgoing',
  'camera',
  'camping',
  'car',
  'caret-down',
  'caret-left',
  'caret-right',
  'caret-up',
  'carrot',
  'chart-connected',
  'chart-histogram',
  'chart-network',
  'chart-pie-alt',
  'chart-pie',
  'chart-pyramid',
  'chart-set-theory',
  'chart-tree',
  'chat-arrow-down',
  'chat-arrow-grow',
  'check',
  'checkbox',
  'cheese',
  'chess-piece',
  'child-head',
  'circle-small',
  'circle',
  'clip',
  'clock',
  'cloud-check',
  'cloud-disabled',
  'cloud-download',
  'cloud-share',
  'cloud-upload',
  'cloud',
  'clouds',
  'cocktail',
  'coffee',
  'comment-alt',
  'comment-check',
  'comment-heart',
  'comment-info',
  'comment-user',
  'comment',
  'comments',
  'compress-alt',
  'compress',
  'computer',
  'confetti',
  'cookie',
  'copy-alt',
  'copy',
  'copyright',
  'cow',
  'cream',
  'credit-card',
  'croissant',
  'cross-circle',
  'cross-small',
  'cross',
  'crown',
  'cube',
  'cupcake',
  'cursor-finger',
  'cursor-plus',
  'cursor-text-alt',
  'cursor-text',
  'cursor',
  'dart',
  'dashboard',
  'data-transfer',
  'database',
  'delete',
  'diamond',
  'dice',
  'diploma',
  'disco-ball',
  'disk',
  'doctor',
  'document-signed',
  'document',
  'dollar',
  'download',
  'drink-alt',
  'drumstick',
  'duplicate',
  'e-learning',
  'earnings',
  'edit-alt',
  'edit',
  'envelope-ban',
  'envelope-download',
  'envelope-marker',
  'envelope-open',
  'envelope-plus',
  'envelope',
  'euro',
  'exclamation',
  'expand',
  'eye-crossed',
  'eye-dropper',
  'eye',
  'feather',
  'ferris-wheel',
  'file-add',
  'file-ai',
  'file-check',
  'file-delete',
  'file-eps',
  'file-gif',
  'file-music',
  'file-psd',
  'file',
  'fill',
  'film',
  'filter',
  'fingerprint',
  'fish',
  'flag',
  'flame',
  'flip-horizontal',
  'flower-bouquet',
  'flower-tulip',
  'flower',
  'folder-add',
  'folder',
  'following',
  'football',
  'form',
  'forward',
  'fox',
  'frown',
  'ftp',
  'gallery',
  'gamepad',
  'gas-pump',
  'gem',
  'gift',
  'glass-cheers',
  'glasses',
  'globe-alt',
  'globe',
  'golf',
  'graduation-cap',
  'graphic-tablet',
  'grid-alt',
  'grid',
  'guitar',
  'gym',
  'hamburger',
  'hand-holding-heart',
  'hastag',
  'hat-birthday',
  'head-side-thinking',
  'headphones',
  'headset',
  'heart-arrow',
  'heart',
  'home-location-alt',
  'home-location',
  'home',
  'hourglass-end',
  'hourglass',
  'ice-cream',
  'ice-skate',
  'id-badge',
  'inbox',
  'incognito',
  'indent',
  'infinity',
  'info',
  'interactive',
  'interlining',
  'interrogation',
  'italic',
  'jpg',
  'key',
  'keyboard',
  'kite',
  'label',
  'laptop',
  'lasso',
  'laugh',
  'layers',
  'layout-fluid',
  'leaf',
  'letter-case',
  'life-ring',
  'line-width',
  'link',
  'lipstick',
  'list-check',
  'list',
  'location-alt',
  'lock-alt',
  'lock',
  'logo-facebook',
  'logo-instagram',
  'logo-linkedin',
  'logo-messenger',
  'logo-pinterest',
  'logo-reddit',
  'logo-snapchat',
  'logo-telegram',
  'logo-tiktok',
  'logo-tumblr',
  'logo-whatsapp',
  'logo-x',
  'logo-youtube',
  'luggage-rolling',
  'magic-wand',
  'makeup-brush',
  'man-head',
  'map-marker-cross',
  'map-marker-home',
  'map-marker-minus',
  'map-marker-plus',
  'map-marker',
  'map',
  'marker-time',
  'marker',
  'mars-double',
  'mars',
  'mask-carnival',
  'medicine',
  'megaphone',
  'meh',
  'menu-burger',
  'menu-dots-vertical',
  'menu-dots',
  'microphone-alt',
  'microphone',
  'minus-small',
  'minus',
  'mobile',
  'mode-landscape',
  'mode-portrait',
  'money',
  'moon',
  'mountains',
  'mouse',
  'mug-alt',
  'music-alt',
  'music',
  'navigation',
  'network-cloud',
  'network',
  'notebook',
  'opacity',
  'package',
  'paint-brush',
  'palette',
  'paper-plane',
  'password',
  'pause',
  'paw',
  'pencil',
  'pharmacy',
  'phone-call',
  'phone-cross',
  'phone-pause',
  'phone-slash',
  'physics',
  'picture',
  'ping-pong',
  'pizza-slice',
  'plane',
  'play-alt',
  'play',
  'playing-cards',
  'plus-small',
  'plus',
  'poker-chip',
  'portrait',
  'pound',
  'power',
  'presentation',
  'print',
  'protractor',
  'pulse',
  'pyramid',
  'quote-right',
  'rainbow',
  'raindrops',
  'rec',
  'receipt',
  'record-vinyl',
  'rectabgle-vertical',
  'rectangle-horizontal',
  'rectangle-panoramic',
  'recycle',
  'redo-alt',
  'redo',
  'reflect',
  'refresh',
  'resize',
  'resources',
  'rewind',
  'rhombus',
  'rings-wedding',
  'road',
  'rocket',
  'room-service',
  'rotate-right',
  'rugby',
  'sad',
  'salad',
  'scale',
  'school-bus',
  'school',
  'scissors',
  'screen',
  'search-alt',
  'search-heart',
  'search',
  'settings-sliders',
  'settings',
  'share',
  'shield-check',
  'shield-exclamation',
  'shield-interrogation',
  'shield-plus',
  'shield',
  'ship-side',
  'ship',
  'shop',
  'shopping-bag-add',
  'shopping-bag',
  'shopping-cart-add',
  'shopping-cart-check',
  'shopping-cart',
  'shuffle',
  'sign-in-alt',
  'sign-in',
  'sign-out-alt',
  'sign-out',
  'signal-alt-1',
  'signal-alt-2',
  'signal-alt',
  'skateboard',
  'smartphone',
  'smile-wink',
  'smile',
  'snowflake',
  'soap',
  'soup',
  'spa',
  'speaker',
  'sphere',
  'spinner-alt',
  'spinner',
  'square-root',
  'square',
  'star-octogram',
  'star',
  'stats',
  'stethoscope',
  'sticker',
  'stop',
  'stopwatch',
  'subtitles',
  'sun',
  'sunrise',
  'surfing',
  'sword',
  'syringe',
  'tablet',
  'target',
  'taxi',
  'tennis',
  'terrace',
  'test-tube',
  'test',
  'text-check',
  'text',
  'thermometer-half',
  'thumbs-down',
  'thumbs-up',
  'thumbtack',
  'ticket',
  'time-add',
  'time-check',
  'time-delete',
  'time-fast',
  'time-forward-sixty',
  'time-forward-ten',
  'time-forward',
  'time-half-past',
  'time-oclock',
  'time-past',
  'time-quarter-past',
  'time-quarter-to',
  'time-twenty-four',
  'tool-crop',
  'tool-marquee',
  'tooth',
  'tornado',
  'train-side',
  'train',
  'transform',
  'trash',
  'treatment',
  'tree-christmas',
  'tree',
  'triangle',
  'trophy',
  'truck-side',
  'umbrella',
  'underline',
  'undo-alt',
  'undo',
  'unlock',
  'upload',
  'usb-pendrive',
  'user-add',
  'user-delete',
  'user-remove',
  'user-time',
  'user',
  'utensils',
  'vector-alt',
  'vector',
  'venus-double',
  'venus-mars',
  'venus',
  'video-camera',
  'volleyball',
  'volume',
  'wheelchair',
  'wifi-alt',
  'wind',
  'woman-head',
  'world',
  'yen',
  'zoom-in',
  'zoom-out',
];
